import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Star, Clock, Shield, Users, CheckCircle, Sparkles } from "lucide-react";
import BookingModal from "../BookingModal";
import "./Services.css";

import oneWayImg from "../../assets/one-way-trip.png";
import roundTripImg from "../../assets/round-trip.png";
import localTaxiImg from "../../assets/local-taxi.png";
import airportImg from "../../assets/airport-pickup.png";
import weddingImg from "../../assets/wedding-cab.png";
import corporateImg from "../../assets/corporate-travel.webp";

const servicesData = [
  {
    id: 1,
    img: oneWayImg,
    title: "One Way Transfer",
    desc: "Pay only for the distance you travel. Ideal for airport rides, outstation drops, and single-side trips.",
    features: ["Affordable Pricing", "No Hidden Charges", "On-Time Pickup"],
    popular: false
  },
  {
    id: 2,
    img: roundTripImg,
    title: "Round Trip Journey",
    desc: "Same-day or multi-day round travel with return included. Best for tours, family trips, and business visits.",
    features: ["Return Included", "Flexible Timing", "Best for Tours"],
    popular: true
  },
  {
    id: 3,
    img: localTaxiImg,
    title: "Local City Taxi",
    desc: "Book hourly and full-day local cabs for shopping, office travel, events, or city sightseeing.",
    features: ["Hourly Rental", "Full-Day Option", "Local Expert Drivers"],
    popular: false
  },
  {
    id: 4,
    img: airportImg,
    title: "Airport Transfer",
    desc: "Hassle-free pickup and drop service to all major airports. On-time guarantee with professional drivers.",
    features: ["On-Time Guarantee", "Flight Tracking", "Professional Drivers"],
    popular: false
  },
  {
    id: 5,
    img: weddingImg,
    title: "Wedding & Event Ride",
    desc: "Premium cars available for marriage functions, corporate events, and family travel. Clean and fully-maintained vehicles.",
    features: ["Premium Cars", "Clean Vehicles", "Event-Ready"],
    popular: false
  },
  {
    id: 6,
    img: corporateImg,
    title: "Corporate Travel",
    desc: "Comfortable and reliable cabs for daily office travel. Perfect for employees, executives, and business meetings.",
    features: ["Reliable Service", "Executive Comfort", "Bulk Booking"],
    popular: false
  },
];

const Services = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleBookNow = () => {
    setShowPopup(true);
    document.body.style.overflow = "hidden";
  };

  const closePopup = () => {
    setShowPopup(false);
    document.body.style.overflow = "auto";
  };

  return (
    <>
      <section className="services" id="services">
        {/* Decorative Elements */}
        <div className="services-decoration"></div>
        <div className="services-grid-pattern"></div>

        {/* Header */}
        <div className="services-header">
          <div className="services-eyebrow">
            <Sparkles size={14} />
            Our Services
          </div>
          <h2>Premium <span>Cab Services</span> for Every Need</h2>
          <p>Choose from our wide range of transportation solutions designed to make your journey comfortable and hassle-free.</p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {servicesData.map((service) => (
            <div className={`service-card ${service.popular ? 'popular' : ''}`} key={service.id}>
              <div className="service-image-wrapper">
                <img src={service.img} alt={service.title} loading="lazy" />
                <div className="service-image-scrim"></div>

                <span className="service-number">0{service.id}</span>

                {service.popular && (
                  <div className="service-popular-badge">
                    <Star size={11} fill="currentColor" stroke="none" />
                    Most Popular
                  </div>
                )}

                <div className="service-title-overlay">
                  <h3>{service.title}</h3>
                </div>
              </div>

              <div className="service-content">
                <p>{service.desc}</p>

                <div className="service-features">
                  {service.features.map((feature, index) => (
                    <span key={index} className="service-feature">
                      <CheckCircle size={12} />
                      {feature}
                    </span>
                  ))}
                </div>

                <button className="book-now-btn" onClick={handleBookNow}>
                  <span>Book Now</span>
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Trust strip */}
        <div className="services-trust-strip">
          <div className="trust-item">
            <Shield size={18} />
            <span>Verified Drivers</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <Clock size={18} />
            <span>24/7 Availability</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <Users size={18} />
            <span>500+ Happy Riders</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <Star size={18} fill="currentColor" stroke="none" />
            <span>4.8 / 5 Average Rating</span>
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      <BookingModal isOpen={showPopup} onClose={closePopup} />
    </>
  );
};

export default Services;